"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useImageInputContext = exports.ImageInputContextProvider = exports.ImageInputContext = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = require("styled-components");
var useFakeUploadMedia_1 = require("../../utilsOolib/useFakeUploadMedia");
var bannerContext_1 = require("../Banners/bannerContext");
exports.ImageInputContext = (0, react_1.createContext)();
var ImageInputContextProvider = function (_a) {
    var children = _a.children, value = _a.value, multiple = _a.multiple, allowedFormats = _a.allowedFormats, formatConvertConfig = _a.formatConvertConfig, folderName = _a.folderName, bucketEnv = _a.bucketEnv, onChange = _a.onChange, id = _a.id, aspectRatio = _a.aspectRatio, readOnly = _a.readOnly, enableCaptions = _a.enableCaptions, defaultImageSpread = _a.defaultImageSpread, invert = _a.invert, containerShape = _a.containerShape, stretchToFullHeight = _a.stretchToFullHeight, dropzoneLabel = _a.dropzoneLabel, dropzoneSublabel = _a.dropzoneSublabel, disableImageBorder = _a.disableImageBorder, omitEditorTools = _a.omitEditorTools, files = _a.files, showOptionalLabelInDropzone = _a.showOptionalLabelInDropzone, isRequired = _a.isRequired, isInRTE = _a.isInRTE, showImageUploadCaution = _a.showImageUploadCaution;
    var theme = (0, styled_components_1.useTheme)();
    var _b = (0, react_1.useState)(undefined), uploadProgress = _b[0], setUploadProgress = _b[1];
    var handleUploadProgess = function (progress) { return setUploadProgress(progress); };
    var _c = (theme === null || theme === void 0 ? void 0 : theme.useUploadMedia({
        mediaConfigs: {
            allowedFormats: allowedFormats,
            formatConvertConfig: formatConvertConfig,
            folderName: folderName,
            bucketEnv: bucketEnv,
            mediaType: "image"
        },
        handleUploadProgess: handleUploadProgess,
    })) ||
        (0, useFakeUploadMedia_1.useFakeUploadMedia)({ handleUploadProgess: handleUploadProgess }), upload = _c.mutate, isLoading = _c.isLoading; //for storybook purposes cuz we dont have access to mediaupload api here
    var SET_ALERT_BANNER = (0, bannerContext_1.useBannerContext)().SET_ALERT_BANNER;
    var _d = (0, react_1.useState)(0), noOfImagesUploading = _d[0], setNoOfImagesUploading = _d[1];
    var _e = (0, react_1.useState)({}), uploadArgs = _e[0], setUploadArgs = _e[1];
    var _f = (0, react_1.useState)(false), showModal = _f[0], setShowModal = _f[1];
    var _g = (0, react_1.useState)(undefined), publicUrlBeingReplaced = _g[0], setPublicUrlBeingReplaced = _g[1];
    var handleUpload = function (_a) {
        var files = _a.files, callback = _a.callback, publicUrlToReplace = _a.publicUrlToReplace;
        //publicUrlToReplace passed only if replace action
        if (!files)
            return;
        publicUrlToReplace
            ? setPublicUrlBeingReplaced(publicUrlToReplace)
            : setNoOfImagesUploading((files === null || files === void 0 ? void 0 : files.length) || 0);
        upload(files, {
            onSuccess: function (data) {
                //extract out all the successful uploads' fileData
                var successfulUploads = data.reduce(function (result, d) {
                    return d.status === "success" ? __spreadArray(__spreadArray([], result, true), [d.fileData], false) : result;
                }, []);
                //error banner for all failed uploads
                data.forEach(function (d) {
                    return d.status === "error" && SET_ALERT_BANNER(d.message, "red", 3500);
                });
                callback({ successfulUploads: successfulUploads });
                publicUrlToReplace
                    ? setPublicUrlBeingReplaced(undefined)
                    : setNoOfImagesUploading(0);
            },
            onError: function (err) {
                var _a;
                SET_ALERT_BANNER(((_a = err.response) === null || _a === void 0 ? void 0 : _a.data.errors[0].msg) || err.message, "red", 4000);
                publicUrlToReplace
                    ? setPublicUrlBeingReplaced(undefined)
                    : setNoOfImagesUploading(0);
            },
        });
    };
    var handleUploadWithCheck = function (args) {
        var item = localStorage.getItem("PreUploadImageCautionAcknowleged");
        if (item && JSON.parse(item)) {
            handleUpload(__assign({}, args));
        }
        else {
            setUploadArgs(args);
            setShowModal(true);
        }
    };
    /**
     * this is specifically required in the RTE scenario,
     * wherein, the minute files are uploaded from the RTE,
     * we want to generate the ImageInput, so that things like
     * loading state, errors etc, are handled internally.
     *
     * Very important to remember though, that in other cases,
     * files prop SHOULD NOT BE PASSED, else everytime the comp
     * renders for the first time, it will upload said files to
     * cloud storage.
     */
    (0, react_1.useEffect)(function () {
        if (files) {
            handleUpload({
                files: files,
                callback: function (_a) {
                    var successfulUploads = _a.successfulUploads;
                    onChange(id, multiple
                        ? __spreadArray(__spreadArray([], successfulUploads, true), (value || []), true) : successfulUploads);
                }
            });
        }
    }, []);
    // Create a ref to always track the latest value
    var valueRef = (0, react_1.useRef)(value);
    // Keep the ref updated whenever value changes
    (0, react_1.useEffect)(function () {
        valueRef.current = value;
    }, [value]);
    var handleSingleImageDataChange = function (_a) {
        var publicUrl = _a.publicUrl, imageData = _a.imageData;
        //publicUrl is used as an 'id' identifier
        var currentValue = valueRef.current;
        var newValue = __spreadArray([], currentValue, true);
        var imgIdxToReplace = newValue.findIndex(function (d) { return d.publicUrl === publicUrl; });
        newValue[imgIdxToReplace] = imageData;
        onChange(id, newValue);
    };
    var handleDeleteSingleImage = function (_a) {
        var publicUrl = _a.publicUrl;
        var newValue = __spreadArray([], value, true);
        newValue = newValue.filter(function (d) { return d.publicUrl !== publicUrl; });
        onChange(id, newValue);
    };
    var handleReplaceSingleImage = function (_a) {
        var publicUrl = _a.publicUrl, newImage = _a.newImage;
        var newValue = __spreadArray([], value, true);
        var idx = newValue.findIndex(function (d) { return d.publicUrl === publicUrl; });
        newValue[idx] = newImage;
        onChange(id, newValue);
    };
    var _h = (0, react_1.useState)(false), imageUnderEdit = _h[0], setImageUnderEdit = _h[1];
    return (react_1.default.createElement(exports.ImageInputContext.Provider, { value: {
            //props
            id: id,
            value: value,
            onChange: onChange,
            multiple: multiple,
            allowedFormats: allowedFormats,
            aspectRatio: aspectRatio,
            readOnly: readOnly,
            enableCaptions: enableCaptions,
            defaultImageSpread: defaultImageSpread,
            invert: invert,
            containerShape: containerShape,
            stretchToFullHeight: stretchToFullHeight,
            dropzoneLabel: dropzoneLabel,
            dropzoneSublabel: dropzoneSublabel,
            disableImageBorder: disableImageBorder,
            omitEditorTools: omitEditorTools,
            //handlers, states initiated in this Context
            upload: upload,
            handleUpload: showImageUploadCaution.enable
                ? handleUploadWithCheck
                : handleUpload,
            noOfImagesUploading: noOfImagesUploading,
            publicUrlBeingReplaced: publicUrlBeingReplaced,
            uploadProgress: uploadProgress,
            isLoading: isLoading,
            handleSingleImageDataChange: handleSingleImageDataChange,
            handleDeleteSingleImage: handleDeleteSingleImage,
            handleReplaceSingleImage: handleReplaceSingleImage,
            imageUnderEdit: imageUnderEdit,
            setImageUnderEdit: setImageUnderEdit,
            showOptionalLabelInDropzone: showOptionalLabelInDropzone,
            isRequired: isRequired,
            isInRTE: isInRTE,
            uploadArgs: uploadArgs,
            showModal: showModal,
            setShowModal: setShowModal,
            showImageUploadCaution: showImageUploadCaution
        } }, children));
};
exports.ImageInputContextProvider = ImageInputContextProvider;
var useImageInputContext = function () {
    return (0, react_1.useContext)(exports.ImageInputContext);
};
exports.useImageInputContext = useImageInputContext;
